module.exports = __webpack_public_path__ + "img/bg01s.818c0ef2.jpg";